import { useCallback } from "react";

import {
  selectIsOptInBarHidden,
  useOptInBarDismissStore,
} from "./optInBarDismissStore";

export const useOptInBarDismiss = () => {
  const dismissedAt = useOptInBarDismissStore(state => state.dismissedAt);
  const dismissFromStore = useOptInBarDismissStore(state => state.dismiss);

  const isHidden = selectIsOptInBarHidden(dismissedAt);
  const shouldShow = !isHidden;

  const dismiss = useCallback(() => {
    dismissFromStore();
  }, [dismissFromStore]);

  return { dismiss, isHidden, shouldShow };
};
